<template>
  <form @submit.prevent="onSearch">
    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div v-if="lastAttemptSuccessDropdown && lastAttemptSuccessDropdown.length">
          <SelectVue
              v-model="filters.lastAttemptSuccess"
              :options="lastAttemptSuccessDropdown"
              :is-clear="true"
              :placeholder="'Status'"/>
        </div>
      </div>
      <div class="col-lg-1 col-md-3 col-sm-12">
        <BaseCheckbox
            v-model="filters.personio"
            :label="'Personio'"
            :labelPosition="'right'"/>
      </div>
      <div class="col-lg-2 col-sm-12 col-12 text-right">
        <SearchButton
            type="submit"
            :label="$t('general.button.search')"
            :loading="loading"/>
      </div>
    </div>
  </form>
</template>

<script setup>
import SelectVue from '@/components/SelectVue.vue';
import {defineEmits, defineProps, toRefs} from 'vue';
import BaseCheckbox from "@/components/base/BaseCheckbox.vue";
import SearchButton from "@/components/button/SearchButton.vue";

const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
  lastAttemptSuccessDropdown: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['search']);

const {filters} = toRefs(props);
const lastAttemptSuccessDropdown = toRefs(props)['lastAttemptSuccessDropdown'];

function onSearch() {
  emit('search', 1, undefined, filters.value);
}
</script>

<style scoped>
</style>
